/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */
import store from '@/store';
import Vue from 'vue'
import jsonVal from "./json/data.json";
import {Guuid,getRouterResources} from "@/assets/js/basis";
import {Message} from 'element-ui'

let vuex = store.state;
export default {
    //类型
    type: 'list',
    //类别
    class: 'chart',
    //组件名称
    name: '列表',
    //排序
    sort: 9,
    //图标
    iconImg: '/img/list.png',
    // 大屏图标
    bigIconImg: '/img/list.png',
    //是否在多维分析展示
    viewType: true,
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 1,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 1,
        //最大度量数量
        maxDLLength: 10,
        //高
        dp_height: 160,
        //宽
        dp_wight: 200,
        //最小高
        dp_min_height: 100,
        //宽宽
        dp_min_wight: 100,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: false,
    },
    component: () => import('./component/list.vue'),
    // 子集展示的配置项
    chilCharts: [
        {
            name: '列表',
            //多维分析图标
            ordImg: '/img/list.png',
            //大屏图标
            bigImg: '/img/list.png',
            //默认配置
            chartParam: {},
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {},
        },
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {
            verticalWidth:20
        }
    },
    //度量组件
    dlComponent: () => import('./dlParam/dlParam'),
    //度量参数
    dlHandle(option) {
        return {
            verticalWidth: 40,
            maxNum: 90
        }
    },
    //配置参数
    params(option) {
        return {
            loop: true,
            timeSwiper: null,
            time: 2000,
            titleStyle: {
                borderWidth: 1,
                borderColor: '#00a3e8',
                borderType: 'solid',
                align: 'center',
                height: 30,
                font: {
                    color: '#00a3e8',
                    fontSize: 16,
                    fontWeight: 400,
                    fontFamily: 'sans-serif'
                },
                background: {
                    type: 'color',
                    picture: '',
                    color: '',
                    border: '',
                }
            },
            bodyStyle: {
                borderWidth: 1,
                borderColor: '#00a3e8',
                borderType: 'dashed',
                align: 'center',
                height: 30,
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    fontSize: 14,
                    fontWeight: 400,
                    fontFamily: 'sans-serif'
                },
                background: {
                    type: 'color',
                    picture: '',
                    colorGroup: '',
                    border: '',
                },
                margin: {
                    top: 0,
                    bottom: 0
                }
            },
            scrllOrswiper: 'scroll',
            dataList: [],
            nameList: [],
            //定时器
            _timerSet: null,
            //dom元素ID
            domId: '',

        }
    },
    //保存时参数的值
    saveParams(option) {
        return {
            //定时器
            _timerSet: null,
            //dom元素ID
            domId: '',
        }
    },
    //配置组件列表
    configModule: [{
        name: '列表配置',
        component: () => import('./config/list_config.vue'),
    }, {
        name: '字体配置',
        component: () => import('./config/listWord_config.vue'),
    }, {
        name: '背景配置',
        component: () => import('./config/listBack_config.vue'),
    }],
    // //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度1'],
            //度量
            dl: ['度量1']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {

            chart.data = {};
        }
    },
    //切换图表之前的回调
    renderBefore(chart, nowChart) {
        nowChart.comConfig.gridType = 3;
    },
    //渲染
    rendering(chart, nowChart) {
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        //度量维度配置
        let config = chart.setting;
        // 图表轴
        let comConfig = nowChart.comConfig;
        let params = config.params;
        // 维度配置参数
        let wdParams = config.wdList;
        // 度量配置参数
        let dlParams = config.dlList;
        //维度名称
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //数据
        let dataVal = dataAll.dt;

        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }

        // //判断数据是否超过15条  grid专用
        let isDataLengthToNum = function () {
            let min = 15;
            if (!dataAll.dt) return false;
            if (dataAll.dt.length > min) {
                return true;
            } else {
                return false;
            }
        };


        // log(isDataLengthToNum)
        let nameList = [];
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
                var idx = nameList.indexOf(i);
                if (idx < 0) {
                    nameList.push(i)
                }
            }
            dataVal[index] = da;
        });
        params.nameList = nameList;
        params.dataList = dataVal;
        let time = Number(params.time);
        let height = params.bodyStyle.height;
        if (!params.domId) {
            params.domId = 'listDom_' + Guuid();
        }
        clearInterval(params._timerSet);
        let count = null;
        params._timerSet = setInterval(function () {
            count++;
            // console.log(params.domId, count, '重复开始了s');
            $('#' + params.domId).find('.info_body').find('div').eq(0).animate({
                height: 0,
            }, function () {
                $(this).appendTo($('#' + params.domId).find('.info_body')).height(height);
            })
        }, time);
        store.dispatch('renderSaveChart', chart);

        let a = 0;
        dlParams.map((va, index, array) => {
            a = a + parseInt(va.params.verticalWidth);
        });


        if (params.scrllOrswiper == 'swiper') {
            clearInterval(params._timerSet);
            count = null;
            params._timerSet = setInterval(function () {
                count++;
                // console.log(params.domId, count, '重复开始了s');
                $('#' + params.domId).find('.info_body').find('div').eq(0).animate({
                    height: 0,
                }, function () {
                    $(this).appendTo($('#' + params.domId).find('.info_body')).height(height);
                })
            }, time);
        } else {
            clearInterval(params._timerSet);
        }
    }
}
